import { createContext, useEffect, useState } from 'react'
import { ISupplierContext, TSupplierContextProps } from './type'

export const SupplierContext = createContext<ISupplierContext>({
  is_supplier: false,
})

const SupplierProvider = ({ children }: TSupplierContextProps) => {
  const [value, setValue] = useState<ISupplierContext>(() => ({
    is_supplier: window.config.IS_SUPPLIER,
  }))

  useEffect(() => {
    const isSupplierFromEnv = window.config.IS_SUPPLIER
    setValue(prevState => ({ ...prevState, is_supplier: isSupplierFromEnv }))
  }, [])

  return <SupplierContext.Provider value={value}>{children}</SupplierContext.Provider>
}

export default SupplierProvider
